module.exports = __webpack_public_path__ + "static/media/newCurtain.8a2a0334.png";